import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { benchApi } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import Tabs from "../Tabs";

import TabsPane from "../Tabs/TabsPane";

import SimpleReactValidator from 'simple-react-validator';

class partnerBenchMarking extends Component {

  constructor(props) {
    super(props);
      this.state = {
            user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
            authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
            category_list: [],
            list: [], my_list: [],
            pid: [],
            sort_list: [], current_selected: [], type: '', current: ''
        }
        this.validator = new SimpleReactValidator();
        this.getpageData = this.getpageData.bind(this);
        this.handleChangeCategory = this.handleChangeCategory.bind(this);
        this.handleChangeOrganisation = this.handleChangeOrganisation.bind(this);
        
    }
    getpageData = () => {
        const { login_id, set_id } = this.state.user_data;
        let req = JSON.stringify({
            login_id: login_id,
            set_id: set_id,
            role: 3,
            url: 'get_pcategoryV1'
        });
        benchApi(req).then(res => {
            if (res.status == 1) {
                this.setState({
                    category_list: res.category_list,
                    list: res.list,
                    pid: res.pid,
                })
            }
        })
    }
    componentDidUpdate() {
       window.jQuery('.selectpicker').selectpicker('refresh');
    }
    componentDidMount() {
        this.getpageData();
        window.jQuery('.selectpicker').selectpicker('refresh');
    }
    handleChangeCategory = (e) => {
        let propName = e.target.name;
        let propValue = e.target.value;
         

        this.setState({
            [propName]: propValue
        })

        const { login_id, set_id } = this.state.user_data;
        let sort_list = this.state.list.filter((item) => item.category == propValue);
        let mylist = [];
        if (sort_list.length > 0) {
            mylist = sort_list[0].list.filter((item) => item.vendor_id == login_id && this.state.pid.includes(item.pid.toString()));
        }
        this.setState({
            sort_list: sort_list.length > 0 ? sort_list[0].list : [],
            my_list: mylist
        })

    }

    handleChangeOrganisation = (e) => {
        let propValue = e.target.value;
         
        this.setState({
            current:propValue
        })
        
    }
    handleSelect = (e) => {
        const propName = e.target.name;
        let value = [...e.target.selectedOptions].map((item) => item.value);
        if (value.length > 5) {
            value.shift();
            alert('Select Maximum 5 Items');
        }
        this.setState({ [propName]: value });
    };
    render() {
        this.validator.purgeFields();
        const { category_list, sort_list, list, my_list  } = this.state;

 
        return (
            <React.Fragment>
                <AdminLayout>
                    
                       <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Benchmarking</h4>
                   

                  {list.length==0 && 
                     <div><b><i>Your Account info may be still waiting for approval to use this feature.</i></b></div>
                    }
                    {list.length>0 && 
                  <form onSubmit={this.handleSubmit}>
                                                <div className='row'>
                                                    <div class="form-group col-md-12">
                                                        <label>Category<span class="astrick"></span></label>
                                                        <select className='form-control selectpicker' name='type' value={this.state.type}
                                                            title='Select Category' onChange={this.handleChangeCategory}>
                                                            <option value="">Select Category</option>
                                                            {category_list.map((item, i) => {
                                                                return (
                                                                    <option value={item.category_id}>{item.category_name}</option>
                                                                )
                                                            })}
                                                        </select>
                                                        {this.validator.message(`Category`, this.state.type, 'required', { className: 'text-danger error-msg' })}
                                                    </div>
                                                </div>
                                                {this.state.type != '' &&
                                                    (
                                                        <React.Fragment>
                                                            <div className='row'>
                                                                <div class="form-group col-md-12">
                                                                    <label>Your Organisation <span class="astrick"></span></label>
                                                                                                                                  
                                                                    <select className='form-control selectpicker' name='current' value={this.state.current}
                                                                        title={`Select Your `} onChange={this.handleChangeOrganisation} data-live-search="true">
                                                                        <option value="">Select your organisation</option>
                                                                        {my_list.map((item, i) => {
                                                                            return (
                                                                                <option value={item.id}>
                                                                                    {item.name}
                                                                                </option>
                                                                            )
                                                                        })}

                                                                    </select>
                                                                   
                                                                    {this.validator.message('Your Organisation', this.state.current, 'required', { className: 'text-danger error-msg' })}
                                                                    
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div class="form-group col-md-12">
                                                                    <label>Organisations to Compare<span class="astrick"></span></label>
                                                                    <select className='form-control selectpicker' name='current_selected' value={this.state.current_selected}
                                                                        multiple title={`Select`} onChange={this.handleSelect} data-live-search="true">
                                                                        <option value="">Select Other organisations to compare</option>
                                                                        {sort_list.map((item, i) => {
                                                                            return (
                                                                                <option value={item.id}>
                                                                                    {item.name}
                                                                                </option>
                                                                            )
                                                                        })}

                                                                    </select>
                                                                    {this.validator.message('Organisations to Compare', this.state.current_selected, 'required', { className: 'text-danger error-msg' })}
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )}

                                                <div className='row'>
                                                    <div class="form-group col-md-12">
                                                        <button className='btn btn-primary btn-sm'>Generate</button>
                                                        <button onClick={this.clearOption} className='btn btn-primary btn-sm mar-lft'>Clear</button>
                                                    </div>
                                                </div>
                                                <h5 className='astrick'><b>Notes</b></h5>
                                                <ul>
                                                    <li>
                                                        To compare the institutes, click on benchmarking tab. Select the category and select the school/preschool and the schools to be compared with. Generate button will generate the comparative information (pdf format).
                                                    </li>
                                                </ul>
                  </form>
                    }

                </div>
              </div>
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }



    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            const { login_id, set_id } = this.state.user_data;
            let req = JSON.stringify({
                login_id: login_id,
                set_id: set_id,
                type: this.state.type,
                current_selected: this.state.current_selected,
                current: this.state.current,
                role: 3,
                url: 'generate_pdfV1'
            });
            benchApi(req).then(res => {
                if (res.status === 1) {
                    localStorage.setItem('compare_data', JSON.stringify(res.data));
                    window.open('/partner/bench_mark_view', '_blank');
                } else {
                    let toastr = '';
                    toastr = window.toastr.error;
                    toastr(res.message, {
                        positionClass: "toast-bottom-right",
                        containerId: "toast-bottom-right"
                    });
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }

    }
    clearOption = (e) => {
        e.preventDefault();
        this.setState({
            type: '',
            current_selected: [],
            current: '',
        })
    }    

}

export default partnerBenchMarking;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/benchmarking.jsx